<template>
  <FormField
    :id="id"
    :class="wrapperClass"
    :label="label"
    :label-pin="labelPin"
    :label-class="labelClass"
    :is-disabled="isDisabled"
    :is-field-focused="isFocused || modelValue.length > 0"
    :is-required="isRequired"
    :is-label-visible="isLabelVisible"
    :is-error="isError"
    :message="message"
    :message-fixed="messageFixed"
    :is-message-visible="isMessageVisible"
  >
    <input
      :id="id"
      ref="inputRef"
      v-bind="$attrs"
      :value="modelValue"
      :disabled="isDisabled"
      :placeholder="placeholder"
      :type="type"
      :class="inputClass"
      @input="updateValue"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
    <FormBorder :is-error="isError" />
    <slot />
  </FormField>
</template>

<script setup lang="ts">
import type { FormFieldProps } from './FormField.vue'

type FormInputProps = {
  inputClass?: string
  modelValue: string | number | null
  placeholder?: string
  type?: 'text' | 'email' | 'hidden' | 'search' | 'number' | 'tel' | 'url'
} & Pick<
  FormFieldProps,
  | 'wrapperClass'
  | 'label'
  | 'labelClass'
  | 'labelPin'
  | 'isLabelVisible'
  | 'isRequired'
  | 'isDisabled'
  | 'isError'
  | 'messageFixed'
  | 'message'
  | 'isMessageVisible'
>

defineOptions({
  inheritAttrs: false
})

withDefaults(defineProps<FormInputProps>(), {
  inputClass: `form-input`,
  modelValue: '',
  placeholder: '',
  type: 'text',
  isLabelVisible: true,
  labelPin: true
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}

const inputRef = ref<null | HTMLElement>(null)
const id = useId()
const isFocused = ref(false)
</script>
